import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async getByMarketSessions (marketSessionId) {
    const api = await getApiInstance()
    try {
      const bspOfferResponse = api.get(`/bspOffer/market-session/${marketSessionId}`)
      const dsoRequestResponse = api.get(`/dsoRequest/market-session/${marketSessionId}`)

      const responses = await Promise.all([bspOfferResponse, dsoRequestResponse])
      const [bspOfferData, dsoRequestData] = responses

      return {
        bspOffer: bspOfferData.data,
        dsoRequest: dsoRequestData.data
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Token potrebbe essere scaduto, prova a ottenere un nuovo token
        getOAuthToken()
        const api = await getApiInstance()
        const bspOfferResponse = api.get(`/bspOffer/market-session/${marketSessionId}`)
        const dsoRequestResponse = api.get(`/dsoRequest/market-session/${marketSessionId}`)

        const responses = await Promise.all([bspOfferResponse, dsoRequestResponse])
        const [bspOfferData, dsoRequestData] = responses

        return {
          bspOffer: bspOfferData.data,
          dsoRequest: dsoRequestData.data
        }
      }
      console.error('Errore durante le chiamate API:', error)
      throw error
    }
  },
  async updateDsoRequest (form) {
    const api = await getApiInstance()
    try {
      const response = api.post('dsoRequest/integrate-mip', form)
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.post('dsoRequest/integrate-mip', form)
        return response
      }
      throw error
    }
  },
  async saveDsoRequest (form) {
    const api = await getApiInstance()
    try {
      const response = api.post('dsoRequest/integrate-mip', form)
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.post('dsoRequest/integrate-mip', form)
        return response
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/FlexibilityServicesService.js